import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';

import { Resource } from '../../../resources/Resource';
import { GetSiteNamesRequest, IGetSiteNamesResult } from '../../../ServerApi/requests/GetSiteNamesRequest';
import { ISiteNameWithId } from '../../../ServerApi/types/ISiteNameWithId';

export class SiteNameWithIds extends Resource<ISiteNameWithId> {

  public static readonly instance = new SiteNameWithIds(new WebClientListResourceFetcher(GetSiteNamesRequest, (result: IGetSiteNamesResult) => {
    return result.siteNames;
  }));

}
